<template>
  <div class="page page_reviews">
    <ReviewsHero />
    <ReviewsList />
  </div>
</template>

<script>
import ReviewsHero from '@/components/reviews/ReviewsHero.vue'
import ReviewsList from '@/components/reviews/ReviewsList.vue'

export default {
  name: 'Reviews',
  components: { ReviewsHero, ReviewsList }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.page {
  padding: 0;
  max-width: none;
  margin: 0;

  &_reviews {
    min-height: auto;
  }
}
</style>
